let version = "1.0.1";

import Vue from "vue";
import App from "./App.vue";
import i18n from "./locales/i18n";

import ElementUI from "element-ui";
// import VCalendar from 'v-calendar';
import "element-ui/lib/theme-chalk/index.css";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
// import VueOffline from 'vue-offline'

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faReply,
  faPen,
  faTasks,
  faListUl,
  faFileDownload,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFilePdf,
  faFile,
  faExclamationCircle,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import "./assets/styles/main.scss";

// import "./registerServiceWorker";

import router from "./router";
import store from "./store";

import Loader from "./components/app/Loader";

import Clipboard from "v-clipboard";

import request_links from "./utils/api_links";
import alert_messages from "./utils/alert_messages";
import change_order from "./utils/change_order";
import parse_message from "./utils/parse_message";
import time_parse from "./utils/time_parse";
import date_parse from "./utils/date_parse";
import decrypt from "./utils/decrypt";
import icon_doc_file from "./utils/iconDocFile";
import parse_doc_size from "./utils/parseDocSize";
import parse_file_type from "./utils/parseFileType";
import hue_color from "./utils/hue_color";
import name_reduction from "./utils/name_reduction";
import throttle from "./utils/throttle";
import email_validate from "./utils/mail_validate";
import downloadFile from "./utils/downloadFile";
import user_color from "./utils/user_color";
import user_image from "./utils/user_avatar";
import resizeImg from "./utils/resizeImg";
import taskData from "./utils/task_data";
import get_image_url from "./utils/get_image_url";
import get_know_user_data from "./utils/get_know_user_data";
import plan from "./utils/plan";
import password from "./utils/password";
import alert from "./utils/alert";
import alert_size from "./utils/alert_size";
import logger from "./utils/logger";
import shiftPaletteHue from "./utils/shiftPaletteHue";
// import aws from "./utils/aws"

import axios from "axios";
import VueAxios from "vue-axios";

import VueRandomColor from "vue-randomcolor";

import VueSocketIO from "vue-socket.io";
import SocketIO from "socket.io-client";
import actionListChat from "./utils/actionListChat";

const socketConnection = SocketIO(process.env.VUE_APP_API_BASE_URL2, {
  autoConnect: false,
  reconnection: false,
  transportOptions: {
    polling: {
      extraHeaders: {
        Authorization: localStorage.getItem("w_token"),
        accept: "web",
      },
    },
  },
  // extraHeaders: { Authorization: localStorage.getItem('w_token') },
});

actionListChat.setSocket(socketConnection);

Vue.use(
  new VueSocketIO({
    debug: process.env.VUE_APP_MODE == "dev" ? true : false,
    connection: socketConnection,
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
  })
);

Vue.use(VueAxios, axios);

Vue.use(VueRandomColor);

Vue.use(Clipboard);

// Vue.use(VCalendar, {
//     componentPrefix: 'vc',
// })

// if (!localStorage.getItem('del1')) {
//     localStorage.clear()
//     localStorage.setItem('del1', true)
// }
// localStorage.clear();

Vue.use(ElementUI);
locale.use(lang);

library.add(
  faReply,
  faPen,
  faTasks,
  faListUl,
  faFileDownload,
  faFileWord,
  faFileExcel,
  faFilePdf,
  faFile,
  faFilePowerpoint,
  faExclamationCircle,
  faClock
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
// Vue.config.productionTip = false;

Vue.component("Loader", Loader);

Vue.prototype.$w_api = request_links;
Vue.prototype.$w_alert = alert_messages;
Vue.prototype.$w_change_order = change_order;
Vue.prototype.$w_parse_message = parse_message;
Vue.prototype.$w_time_parse = time_parse;
Vue.prototype.$w_date_parse = date_parse;
Vue.prototype.$w_decrypt = decrypt;
Vue.prototype.$w_icon_doc_file = icon_doc_file;
Vue.prototype.$w_parse_doc_size = parse_doc_size;
Vue.prototype.$w_parse_file_type = parse_file_type;
Vue.prototype.$w_hue_color = hue_color;
Vue.prototype.$w_name_reduction = name_reduction;
Vue.prototype.$w_throttle = throttle;
Vue.prototype.$w_email_validate = email_validate;
Vue.prototype.$w_downloadFile = downloadFile;
Vue.prototype.$w_user_color = user_color;
Vue.prototype.$w_user_image = user_image;
Vue.prototype.$w_get_image_url = get_image_url;
Vue.prototype.$w_resizeImg = resizeImg;
Vue.prototype.$w_taskData = taskData;
Vue.prototype.$w_get_know_user_data = get_know_user_data;
Vue.prototype.$w_plan = plan;
Vue.prototype.$w_password = password;
Vue.prototype.$w_version = version;
Vue.prototype.$w_alert = alert;
Vue.prototype.$w_alert_size = alert_size;
Vue.prototype.$w_logger = logger;
Vue.prototype.$shiftPaletteHue = shiftPaletteHue;
Vue.prototype.$w_max_upload_file_size = 1073741824; // 5368709120
Vue.prototype.$actionListChat = actionListChat;

// ======= Messages
import planLimit from "./messages/plan-limit";
Vue.prototype.$planMessages = planLimit;
Vue.config.devtools = true;
Vue.config.productionTip = false;

Vue.config.errorHandler = function (err, vm, info) {
  console.group(`Ошибка Vue: ${info}`);
  console.error(err);
  if (vm) {
    console.log("Компонент:", vm.$options.name || "(без имени)");
  }
  console.groupEnd();
};

// let firebaseMessaging = null;
// import { firebaseApp } from './firebase';

// let version_1 = '1.0.1'
// let v = localStorage.getItem('v')

// if (v) {

//   let script = document.querySelectorAll('script')
//   script = Array.from(script)

//   script.forEach((e) => {
//     if (e.src.search('/js/') != -1) {
//       e.src = e.src.replace(`.${version_1}.`, `.${v}.`)
//     }
//   })

//   let link = document.querySelectorAll('link')
//   link = Array.from(link)

//   link.forEach((e) => {
//     if (e.href.search('/js/') != -1) {
//       e.href = e.href.replace(`.${version_1}.`, `.${v}.`)
//     }
//   })

// }

// import { initializeApp } from "@firebase/app";
// import { getMessaging } from "@firebase/messaging/sw";

// const firebaseApp = initializeApp({
//     apiKey: "AIzaSyBHHmjPHMCnT9QjhU9NWV6t8MY5JplI18M",
//     authDomain: "taskpal-769d9.firebaseapp.com",
//     projectId: "taskpal-769d9",
//     storageBucket: "taskpal-769d9.appspot.com",
//     messagingSenderId: "71445455244",
//     appId: "1:71445455244:web:8ca9268f6431431ad236a9",
//     measurementId: "G-BTTGJDJWLF"
// });
// Vue.prototype.$messaging = getMessaging(firebaseApp);
// Vue.prototype.$firebaseApp = firebaseApp;
// if (firebase.messaging.isSupported()) {
// firebaseMessaging = firebase.messaging();
// }

// service worker register
// Inside of build.js:
// const { generateSW } = require('workbox-build');

// const swDest = './sw.js';
// generateSW({
//   swDest,
//   // Other configuration options...
// }).then(({count, size}) => {
//   console.log(`Generated ${swDest}, which will precache ${count} files, totaling ${size} bytes.`);
// });

export const EventEmitter = new Vue();

import AutoReload from "@/plugins/AutoReload";
// import { h } from '@vue/composition-api';
// Vue.use(i18n);

new Vue({
  i18n,
  router,
  store,
  created() {
    Vue.use(AutoReload, {
      config: {
        Enabled: true,
        CheckInterval: process.env.VUE_APP_MODE == "production" ? 60 * 60 : 60,
      },
      router: this.$router,
      vm: this,
    });
  },
  render: (h) => h(App),
}).$mount("#app");
